module.exports = __webpack_public_path__ + "static/media/Grandmas-Sampler_780x390.e313abe0.jpg";